<template>
    <div class="background" v-cloak>
        <div class="loader-container" v-if="loader">
            <Loader/>
        </div>
        <div class="row" v-if="data && !loader">
            <div class="col-md-10 offset-md-1">
                <div class="padding-20">
                    <router-link style="text-decoration: none;color: #121212" :to="{name: 'loans'}"><i
                            class="fas fa-chevron-left"></i> Back - <span style="color: gray"> Loan details</span>
                    </router-link>
                </div>
                <div class="d-flex" style="align-items: baseline;">
                    <div style="font-size: 20px;font-weight: 500;">
                        LOAN ID : <span style="color: #121212">{{data.generated_id}}</span>
                    </div>
                    <div class="btn-group">
                        <button :disabled="data.next_status.length === 0" type="button"
                                class="btn btn-primary dropdown-toggle arrow-btn" style="margin-left: 10px;"
                                :style="{ backgroundColor: status_color }"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ show_status }}
                            <div class="arrow-left"></div>
                        </button>
                        <div class="dropdown-menu" v-if="data.next_status.length !== 0">
                            <span v-for="(status,index) in data.next_status" :key="index"
                                  v-on:click="changeStatus(status)" class="dropdown-item" style="cursor: pointer"><i
                                    class="fas fa-circle" :style="{color: status.extras.color}"
                                    style="margin-right: 10px;"></i>{{status.name}}</span>
                        </div>
                    </div>
                    <div class="button-right">
                        <button data-toggle="modal" data-target="#sendSMS"
                                class="btn btn-light btn-extra margin-left-20"><i
                                class="fas fa-comment-alt"></i> Send SMS
                        </button>
                        <button v-if="!is_micro_loan" class="btn btn-light btn-extra margin-left-20"
                                v-on:click="pdfDownload('proposalLetter')"><i
                                class="fas fa-id-card-alt"></i>
                            Credit proposal
                        </button>
                        <button v-if="!is_micro_loan" class="btn btn-light btn-extra margin-left-20"
                                v-on:click="pdfDownload('sanctionLetter')"><i
                                class="fas fa-id-card-alt"></i>
                            Issue Sanction letter
                        </button>
                        <button class="btn btn-light btn-extra margin-left-20"
                                v-on:click="pdfDownload('application')">
                            <i class="fas fa-cloud-download-alt"></i>
                            Download application
                        </button>
                    </div>
                </div>
                <div class="loan-summery">
                    <div v-if="is_micro_loan" class="robi_retailer">Robi Retailer</div>
                    <p>Loan Summary</p>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4">
                                    Borrower Name
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.final_information_for_loan.personal.name}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    Borrower Phone No.
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.partner.profile.mobile}}</span>
                                </div>
                            </div>
                            <div v-if="!is_micro_loan" class="row">
                                <div class="col-md-4">
                                    Total Installment
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.total_installment}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    Loan Trainer
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.partner.name}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    Bank Name
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.bank.name}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-4">
                                    Loan Amount
                                </div>
                                <div class="col-md-6">
                                    <span>{{ data.loan_amount }}</span>
                                </div>
                            </div>
                            <div class="row" >
                                <div class="col-md-4">
                                    Duration
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.duration}} {{is_micro_loan ? data.duration>1 ? 'days':'day' : data.duration>1?'months':'month'}}</span>
                                </div>
                            </div>

                            <div v-if="!is_micro_loan" class="row">
                                <div class="col-md-4">
                                    Installment amount
                                </div>
                                <div class="col-md-6">
                                    <span>{{data.monthly_installment}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    Loan Type
                                </div>
                                <div class="col-md-6">
                                    <span style="text-transform: capitalize">{{ data.loan_type }} Loan</span>
                                </div>
                            </div>
                            <div class="row" v-if="has_reason">
                                <div class="col-md-4">
                                    Reject reason
                                </div>
                                <div class="col-md-6">
                                    <span style="text-transform: capitalize">{{ data.reject_reason }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="account-info">
                    <div class="d-flex">
                        <p style="cursor:pointer" class="panel-title"><span class="collapsed" data-toggle="collapse"
                                                                            data-target="#accountInfo"
                                                                            aria-expanded="true"
                                                                            aria-controls="changeLogs"> Account Information & Documents </span>
                        </p>
                    </div>
                    <div id="accountInfo" class="collapse">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="inner-div">
                                    <p>Applied Loan Details</p>
                                    <div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Loan Amount
                                            </div>
                                            <!--                                            :class="{'disable-input': is_input_disable, 'enable-input': !is_input_disable}"-->
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.loan_amount">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Duration
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.duration">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div v-if="is_micro_loan" class="col-md-4">
                                                Interest Rate (Per day)
                                            </div>
                                            <div v-else class="col-md-4">
                                                Interest Rate
                                            </div>
                                            <div class="col-md-8">
                                                <input v-if="is_micro_loan" disabled class="form-control" type="text"
                                                       value="0.08%">
                                                <input v-else :disabled="is_input_disable" class="form-control" type="text"
                                                     v-model="data.interest_rate">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Credit Score
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.credit_score">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Purpose
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.purpose">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Disbursement amount
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.finance.disbursement_amount">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="inner-div" style="float: right;margin-top: 50px;">
                                    <img style="border-radius: 8px" height="250" width="250"
                                         :src="data.final_information_for_loan.document.picture" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="inner-div">
                                    <p>Proprietors Details</p>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="data.partner.profile.is_nid_verified" class="form-control"
                                                   type="text"
                                                   v-model="data.final_information_for_loan.personal.name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Gender
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.gender">
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Date of Birth
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="data.partner.profile.is_nid_verified"
                                                        input-class="date-picker" format="dd MMMM yyyy"
                                                        v-model="data.final_information_for_loan.personal.birthday"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Place of Birth
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.birth_place">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Fathers Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.father_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Mothers Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.mother_name">
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Spouse Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.spouse_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            E-mail
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.email">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            NID/Passport no.
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="data.partner.profile.is_nid_verified" class="form-control"
                                                   type="text"
                                                   v-model="data.final_information_for_loan.personal.nid_no">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            NID Issue date
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.personal.nid_issue_date"></datepicker>
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Other ID (If any)
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.other_id">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Other ID Issue date
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.personal.other_id_issue_date"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            E-TIN number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.tin_no">
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Net worth
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.net_worth">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Present Address</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Street
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.present_address.street">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            PS/Upozilla
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.present_address.thana">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            District
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.present_address.zilla">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Postal Code
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.present_address.post_code">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Country
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.present_address.country">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Permanent Address</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Street
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.permanent_address.street">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            PS/Upozilla
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.permanent_address.thana">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            District
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.permanent_address.zilla">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Postal Code
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.permanent_address.post_code">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Country
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.personal.permanent_address.country">
                                        </div>
                                    </div>
                                </div>

                                <div class="inner-div">
                                    <p>Proposal Letter</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Management memo no
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.management_memo_no">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Key sponsor name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.key_sponsor_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            CIB status
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.cib_status">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Client profile
                                        </div>
                                        <div class="col-md-8">
                                            <textarea :disabled="is_input_disable" class="form-control" cols="10" rows="4"
                                                      v-model="data.final_information_for_loan.proposal_info.client_profile"></textarea>

                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Loan type (Facility)
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.loan_type">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Outstanding
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.outstanding">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Overdue
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.overdue">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Remarks
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.remarks">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total current assets
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.total_current_asset">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total equity
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.total_equity">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Net profit
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.net_profit">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Profit ratio (overall)
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.profit_ratio">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total existing monthly Debt repayment
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.existing_debt_repayment">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            DBR%
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.dbr">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            IPDC equity
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.ipdc_equity">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Disbursement to
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.disbursement_to">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Availability (Proposal letter)
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.availability">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Supplier Category
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.supplier_category">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Performance with IPDC
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.performance_with_IPDC">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            No of client
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.no_of_client">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Approved amount
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.approved_amount">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Disbursement amount
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.disbursement_amount">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Repayment amount
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.repayment_amount">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Exposure Limit
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.exposure_limit">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Remark
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.proposal_info.remark">
                                        </div>
                                    </div>
                                </div>

                                <div class="inner-div">
                                    <p>Sanction Latter</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Short Name of Company
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.business.short_name"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Penal interest
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.sanction_letter_info.panel_interest"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Documentation and processing fee
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.sanction_letter_info.documentation_and_processing_fee"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Number of cheque submitted by client
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.sanction_letter_info.no_of_checks_submitted"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Referance number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.sanction_letter_info.reference_no"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="inner-div">
                                    <p>Business Details</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Business Name
                                        </div>
                                        <div class="col-md-8">
                                            <textarea :disabled="is_input_disable" class="form-control" cols="10"
                                                      rows="4"
                                                      v-model="data.final_information_for_loan.business.business_name"></textarea>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Nature of Business
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable" class="form-control"
                                                    v-model="data.final_information_for_loan.business.smanager_business_type">
                                                <option v-for="type in data.final_information_for_loan.business.smanager_business_types">
                                                    {{ type.bn }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Legal Status
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable" class="form-control"
                                                    v-model="data.final_information_for_loan.business.ownership_type">
                                                <option v-for="type in data.final_information_for_loan.business.ownership_types">
                                                    {{ type.bn }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Business Type
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable" class="form-control"
                                                    v-model="data.final_information_for_loan.business.business_type">
                                                <option value="null">Select One</option>
                                                <option v-for="type in data.final_information_for_loan.business.business_types"
                                                        :value="type.bn">
                                                    {{ type.bn }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            E-TIN number (company)
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.tin_no">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Issue Date
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="e_tin_company_issue_date"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Date of Starting with Sheba
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.business.establishment_year"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Number of online order serve
                                        </div>
                                        <div class="col-md-8">
                                            <input disabled class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.online_order">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Trade License No
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.trade_license">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Date of Establishment
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.business.date_of_establishment"></datepicker>

                                        </div>
                                    </div>
                                    <div v-if="is_micro_loan">
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                District
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.business.business_additional_information.address.zilla">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                PS/Upozilla
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.business.business_additional_information.address.thana">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Street
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.business.business_additional_information.address.street">
                                            </div>
                                        </div>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Post code
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.business.business_additional_information.address.post_code">
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="row item-align-center">
                                            <div class="col-md-4">
                                                Address
                                            </div>
                                            <div class="col-md-8">
                                                <input :disabled="is_input_disable" class="form-control" type="text"
                                                       v-model="data.final_information_for_loan.business.location">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Industry and business nature
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                        v-model="data.final_information_for_loan.business.industry_and_business_nature">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Sector
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable"  class="form-control"
                                                    v-model="data.final_information_for_loan.business.sector" >
                                                <option value="null" hidden> Select a sector</option>
                                                <option v-for="sector in data.final_information_for_loan.business.sectors">
                                                    {{ sector }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Business category
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable" class="form-control"
                                                    v-model="data.final_information_for_loan.business.business_category">
                                                <option value="null" hidden> Select a category</option>
                                                <option v-for="category in data.final_information_for_loan.business.business_categories">
                                                    {{ category }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Bank Details</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Account Title
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.acc_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Account Number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.acc_no">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Acc Type
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.acc_type">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Bank Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.bank_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Branch
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.branch_name">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Period
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.period">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Debit sum
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.debit_sum">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Credit sum
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.credit_sum">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Monthly AVG credit sum
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.monthly_avg_credit_sum">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Routing number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.finance.routing_no">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Business Performance</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total 6 Month Sale
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.last_six_month_sales_information.min_sell">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total 6 Month Cost
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.business_additional_information.other_cost">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Total Fixed Asset
                                        </div>
                                        <div class="col-md-8">
                                            <input  :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.fixed_asset">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Number of Employee
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.full_time_employee">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Value of Stock
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable" class="form-control" type="text"
                                                   v-model="data.final_information_for_loan.business.stock_price">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Proposed Security Details</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Security
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.business.security_check"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Strategic partner
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.business.strategic_partner"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="inner-div">
                                    <p>1st Grantor information</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.name"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Phone number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.mobile"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            date of birth
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.nominee_granter.grantor.dob"></datepicker>

                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Relation
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.grantor_relation"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Occupation
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.occupation"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Net worth
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.net_worth"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Address
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.grantor.address"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>2nd Grantor information</p>

                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Name
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.name"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Phone number
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.mobile"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            date of birth
                                        </div>
                                        <div class="col-md-8">
                                            <datepicker :disabled="is_input_disable" input-class="date-picker"
                                                        v-model="data.final_information_for_loan.nominee_granter.nominee.dob"></datepicker>

                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Relation
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.nominee_relation"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Occupation
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.occupation"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Net worth
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.net_worth"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Address
                                        </div>
                                        <div class="col-md-8">
                                            <input :disabled="is_input_disable"
                                                   v-model="data.final_information_for_loan.nominee_granter.nominee.address"
                                                   class="form-control" type="text">
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-div">
                                    <p>Loan Group</p>
                                    <div class="row item-align-center">
                                        <div class="col-md-4">
                                            Loan Group
                                        </div>
                                        <div class="col-md-8">
                                            <select :disabled="is_input_disable" class="form-control"
                                                    v-model="data.groups"
                                                    placeholder="Select Group"
                                                    id="loan_groups">
                                                <option value="null">Select One</option>
                                                <option v-for="group in data.loan_groups"
                                                        :value="group">
                                                    {{ group }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inner-div">
                                    <button class="btn btn-primary custom_button" v-on:click="saveChanges">Save
                                        Changes
                                    </button>
                                    <button class="btn btn-light btn-discard" v-on:click="discardChanges">Discard
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inner-div">
                                    <div>
                                        <button class="btn btn-primary float-right" style="padding: 6px 40px"
                                                v-on:click="downloadAllDocuments"><i
                                                class="fas fa-download" style="margin-right:10px"></i>Download All
                                            Documents
                                        </button>
                                        <p>Document</p>
                                    </div>
                                    <div class="row">
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.picture"
                                                     class="image" width="100%"
                                                     :src="data.final_information_for_loan.document.picture" alt="">
                                                <img v-else
                                                     class="image" width="100%" :src="placeholder_image"/>
                                            </div>
                                            <h5 style="margin-top:10px">Profile picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.picture)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white;margin-right: 10px"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.picture)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.picture,'profile','picture')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img class="image" width="100%"
                                                     v-if="data.final_information_for_loan.document.nid_image_front"
                                                     :src="data.final_information_for_loan.document.nid_image_front"
                                                     alt="">
                                                <img :src="placeholder_image" class="image" width="100%" alt="" v-else>
                                            </div>
                                            <h5 style="margin-top:10px">NID front picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.nid_image_front)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.nid_image_front)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.nid_image_front,'profile','nid image front')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.nid_image_back"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.nid_image_back"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">NID back picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.nid_image_back)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.nid_image_back)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.nid_image_back,'profile','nid image back')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.grantor_document.picture"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.grantor_document.picture"
                                                     alt="">
                                                <img :src="placeholder_image" v-else alt="" class="image">
                                            </div>
                                            <h5 style="margin-top:10px">1st Grantor's profile picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.grantor_document.picture)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.grantor_document.picture)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.grantor_document.picture,'grantor_document','picture')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.grantor_document.nid_front_image"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.grantor_document.nid_front_image"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">1st Grantor's NID front picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.grantor_document.nid_front_image)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.grantor_document.nid_front_image)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.grantor_document.nid_front_image,'grantor_document','nid front image')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.grantor_document.nid_back_image"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.grantor_document.nid_back_image"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" class="image" v-else>
                                            </div>
                                            <h5 style="margin-top:10px">1st Grantor's NID back picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.grantor_document.nid_back_image)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.grantor_document.nid_back_image)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.grantor_document.nid_back_image,'grantor_document','nid back image')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.nominee_document.picture"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.nominee_document.picture"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">2nd Grantor's picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.nominee_document.picture)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.nominee_document.picture)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.nominee_document.picture,'nominee_document','picture')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.nominee_document.nid_front_image"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.nominee_document.nid_front_image"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">2nd Grantor's NID front picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.nominee_document.nid_front_image)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.nominee_document.nid_front_image)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.nominee_document.nid_front_image,'nominee_document','nid front image')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.nominee_document.nid_back_image"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.nominee_document.nid_back_image"
                                                     alt="">
                                                <img :src="placeholder_image" v-else class="image" alt="">
                                            </div>
                                            <h5 style="margin-top:10px">2nd Grantor's NID back picture</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.nominee_document.nid_back_image)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.nominee_document.nid_back_image)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.nominee_document.nid_back_image,'nominee_document','nid back image')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.business_document.tin_certificate"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.business_document.tin_certificate"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">Tin certificate</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.business_document.tin_certificate)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.business_document.tin_certificate)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.business_document.tin_certificate,'business_document','tin certificate')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.business_document.trade_license_attachment"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.business_document.trade_license_attachment"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">Trade license</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.business_document.trade_license_attachment)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.business_document.trade_license_attachment)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.business_document.trade_license_attachment,'business_document','trade_license_attachment')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div class="image-div">
                                                <img v-if="data.final_information_for_loan.document.business_document.statement"
                                                     class="image" width="100%" height="220px"
                                                     :src="data.final_information_for_loan.document.business_document.statement"
                                                     alt="">
                                                <img :src="placeholder_image" alt="" v-else class="image">
                                            </div>
                                            <h5 style="margin-top:10px">Bank Statement</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(data.final_information_for_loan.document.business_document.statement)"><i
                                                            class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(data.final_information_for_loan.document.business_document.statement)"><i
                                                            class="fas fa-download"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(data.final_information_for_loan.document.business_document.statement,'business_document','statement')"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                      <div class="doc-div image-container">
                                        <div class="image-div">
                                          <img v-if="data.final_information_for_loan.business.business_additional_information.proof_of_photograph"
                                               class="image" width="100%" height="220px"
                                               :src="data.final_information_for_loan.business.business_additional_information.proof_of_photograph"
                                               alt="">
                                          <img :src="placeholder_image" alt="" v-else class="image">
                                        </div>
                                        <h5 style="margin-top:10px">Proof of business</h5>
                                        <small>{{ data.partner.profile.updated_at}}</small>
                                        <div class="middle">
                                          <div class="text">
                                            <a style="cursor: pointer;margin-right:10px;color: white"
                                               v-on:click="showImage(data.final_information_for_loan.business.business_additional_information.proof_of_photograph)"><i
                                                class="fas fa-eye"></i></a>
                                            <a style="cursor: pointer; color: white"
                                               v-on:click="downloadSingleImage(data.final_information_for_loan.business.business_additional_information.proof_of_photograph)"><i
                                                class="fas fa-download"></i></a>
                                            <a style="cursor: pointer; color: white"
                                               v-on:click="updateSingleImage(data.final_information_for_loan.business.business_additional_information.proof_of_photograph,'proof_of_photograph','proof_of_photograph')"><i
                                                class="fas fa-edit"></i></a>
                                          </div>
                                        </div>
                                      </div>

                                        <div class="doc-div image-container" v-if="data.final_information_for_loan.document.retailer_document">
                                                <div class="image-div">
                                                    <img v-if="data.final_information_for_loan.document.retailer_document.application"
                                                         class="image" width="100%" height="220px"
                                                         :src="data.final_information_for_loan.document.retailer_document.application"
                                                         alt="">
                                                    <img :src="placeholder_image" alt="" v-else class="image">
                                                </div>
                                                <h5 style="margin-top:10px">Application</h5>
                                                <small>{{ data.partner.profile.updated_at}}</small>
                                                <div class="middle">
                                                    <div class="text">
                                                        <a style="cursor: pointer;margin-right:10px;color: white"
                                                           v-on:click="showImage(data.final_information_for_loan.document.retailer_document.application)"><i
                                                                class="fas fa-eye"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="downloadSingleImage(data.final_information_for_loan.document.retailer_document.application)"><i
                                                                class="fas fa-download"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="updateSingleImage(data.final_information_for_loan.document.retailer_document.application,'application','application')"><i
                                                                class="fas fa-edit"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="doc-div image-container" v-if="data.final_information_for_loan.document.retailer_document">
                                                <div class="image-div">
                                                    <img v-if="data.final_information_for_loan.document.retailer_document.charge_document"
                                                         class="image" width="100%" height="220px"
                                                         :src="data.final_information_for_loan.document.retailer_document.charge_document"
                                                         alt="">
                                                    <img :src="placeholder_image" alt="" v-else class="image">
                                                </div>
                                                <h5 style="margin-top:10px">Charge document</h5>
                                                <small>{{ data.partner.profile.updated_at}}</small>
                                                <div class="middle">
                                                    <div class="text">
                                                        <a style="cursor: pointer;margin-right:10px;color: white"
                                                           v-on:click="showImage(data.final_information_for_loan.document.retailer_document.charge_document)"><i
                                                                class="fas fa-eye"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="downloadSingleImage(data.final_information_for_loan.document.retailer_document.charge_document)"><i
                                                                class="fas fa-download"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="updateSingleImage(data.final_information_for_loan.document.retailer_document.charge_document,'application','application')"><i
                                                                class="fas fa-edit"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="doc-div image-container" v-if="data.final_information_for_loan.document.retailer_document">
                                                <div class="image-div">
                                                    <img v-if="data.final_information_for_loan.document.retailer_document.credit_proposal"
                                                         class="image" width="100%" height="220px"
                                                         :src="data.final_information_for_loan.document.retailer_document.credit_proposal"
                                                         alt="">
                                                    <img :src="placeholder_image" alt="" v-else class="image">
                                                </div>
                                                <h5 style="margin-top:10px">Credit proposal</h5>
                                                <small>{{ data.partner.profile.updated_at}}</small>
                                                <div class="middle">
                                                    <div class="text">
                                                        <a style="cursor: pointer;margin-right:10px;color: white"
                                                           v-on:click="showImage(data.final_information_for_loan.document.retailer_document.credit_proposal)"><i
                                                                class="fas fa-eye"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="downloadSingleImage(data.final_information_for_loan.document.retailer_document.credit_proposal)"><i
                                                                class="fas fa-download"></i></a>
                                                        <a style="cursor: pointer; color: white"
                                                           v-on:click="updateSingleImage(data.final_information_for_loan.document.retailer_document.credit_proposal,'application','application')"><i
                                                                class="fas fa-edit"></i></a>
                                                    </div>
                                                </div>
                                            </div>

                                        <div v-for="(image,index) in data.final_information_for_loan.document.extras"
                                             class="doc-div image-container" :key="index">
                                            <div class="image-div">
                                                <img class="image" width="100%" height="220px"
                                                     :src="image"
                                                     alt="">
                                            </div>
                                            <h5 style="margin-top:10px">{{ nameFormat(index)}}</h5>
                                            <small>{{ data.partner.profile.updated_at}}</small>
                                            <div class="middle">
                                                <div class="text">
                                                    <a style="cursor: pointer;margin-right:10px;color: white"
                                                       v-on:click="showImage(image)"><i class="fas fa-eye"></i></a>
                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="downloadSingleImage(image)"><i
                                                            class="fas fa-download"></i></a>

                                                    <a style="cursor: pointer; color: white"
                                                       v-on:click="updateSingleImage(image,'extras',index)"><i
                                                            class="fas fa-edit"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-div image-container">
                                            <div style="cursor: pointer" class="image-div extras"
                                                 v-on:click="updateSingleImage(null,'extras','')">
                                                <img width="100%" height="220px" src="../assets/download.jpg" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

<!--                <div class="account-info" v-if="data.loan_type === loanTypes.micro">-->
<!--                    <div class="d-flex">-->
<!--                        <p style="cursor:pointer" class="panel-title"><span class="collapsed" data-toggle="collapse"-->
<!--                                                                            data-target="#bankDeposit"-->
<!--                                                                            aria-expanded="true"-->
<!--                                                                            aria-controls="changeLogs">Bank Deposit </span>-->
<!--                        </p>-->
<!--                    </div>-->
<!--                    <div id="bankDeposit" class="collapse">-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-6">-->
<!--                                <div class="inner-div">-->
<!--                                    <p>Bank Details Information </p>-->
<!--                                    <div>-->
<!--                                        <div class="row item-align-center">-->
<!--                                            <div class="col-md-4">-->
<!--                                                Deposit Amount-->
<!--                                            </div>-->
<!--                                            <div class="col-md-8">-->
<!--                                                Deposit Amount-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row item-align-center">-->
<!--                                            <div class="col-md-4">-->
<!--                                                Bank Name-->
<!--                                            </div>-->
<!--                                            <div class="col-md-8">-->
<!--                                                Bank Name-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row item-align-center">-->
<!--                                            <div class="col-md-4">-->
<!--                                                Branch Name-->
<!--                                            </div>-->
<!--                                            <div class="col-md-8">-->
<!--                                                Branch Name-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="row item-align-center">-->
<!--                                            <div class="col-md-8">-->
<!--                                                <div class="row">-->
<!--                                                    <div class="col-md-6">-->
<!--                                                        <button class="btn btn-primary btn-block approved" data-toggle="modal" data-target="#depositApproded">Approved</button>-->
<!--                                                    </div>-->
<!--                                                    <div class="col-md-6">-->
<!--                                                        <button class="btn btn-danger btn-block reject" data-toggle="modal" data-target="#depositReject">Reject</button>-->
<!--                                                    </div>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-6">-->
<!--                                <div class="inner-div">-->
<!--                                    <img style="border-radius: 8px" height="300px" width="100%"-->
<!--                                         :src="data.final_information_for_loan.document.picture" alt="">-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-10 offset-md-1">-->
<!--                                <div style="margin-bottom: 20px">-->
<!--                                    Bank receipt approval history-->
<!--                                </div>-->
<!--                                <table class="table table-striped table-bordered table-hover dt-responsive" width="100%">-->
<!--                                    <thead>-->
<!--                                    <tr>-->
<!--                                        <th class="all">Date</th>-->
<!--                                        <th class="all">Status</th>-->
<!--                                        <th class="all">Reject note</th>-->
<!--                                        <th class="all">Amount</th>-->
<!--                                    </tr>-->
<!--                                    </thead>-->
<!--                                    <tbody>-->
<!--                                    <tr v-for="(log,index) in changeLogs" :key="index">-->
<!--                                        <td>{{log.created_at}}</td>-->
<!--                                        <td>{{log.created_at}}</td>-->
<!--                                        <td>{{log.created_at}}</td>-->
<!--                                        <td>{{log.created_at}}</td>-->
<!--                                    </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="account-info" v-if="is_micro_loan">
                    <div class="d-flex">
                        <p style="cursor:pointer" class="panel-title"><span class="collapsed" data-toggle="collapse"
                                                                            data-target="#bankDepositlogs"
                                                                            aria-expanded="true"
                                                                            aria-controls="changeLogs">Repayment Log </span>
                        </p>
                    </div>
                    <div id="bankDepositlogs" class="collapse">
                        <div class="row">
                            <div class="col-md-12" style="margin: 20px 0">
                                <div class="row">
                                    <div class="col-md-4">sManager ROBI loan account log</div>
                                    <div class="col-md-4" style="font-size: 20px">
                                        Due Amount: {{ repayments.due_amount }}
                                    </div>
                                    <div class="col-md-4" style="font-size: 20px">
                                        Credit Balance: {{ repayments.credit_amount }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <table class="table table-striped table-bordered table-hover dt-responsive" width="100%">
                                    <thead>
                                    <tr>
                                        <th class="all">Date</th>
                                        <th class="all">Description</th>
                                        <th class="all">Type</th>
                                        <th class="all">Withdraw</th>
                                        <th class="all">Deposit</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(repayment,index) in repayments.repayment_list" :key="index">
                                        <td>{{ repayment.created_at }}</td>
                                        <td>{{ repayment.log }}</td>
                                        <td>{{ repayment.amount_type }}</td>
                                        <td>{{ repayment.amount_type === 'debit' ? repayment.amount: '' }}</td>
                                        <td>{{ repayment.amount_type === 'credit' ? repayment.amount: '' }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="comment">
                    <p class="panel-title"><span class="collapsed" data-toggle="collapse" data-target="#comment"
                                                 aria-expanded="true" aria-controls="changeLogs"> Comments </span></p>
                    <div id="comment" class="collapse">
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="inner-div">
                                    {{logged_in_user_name}}
                                    <div class="" style="margin:20px 0">
                                        <textarea class="form-control" cols="30" rows="3" placeholder="write here..."
                                                  v-model="newComment"></textarea>
                                    </div>
                                    <button style="font-size:16px;font-weight:bold; color:#2d9cdb;border: none;background: none"
                                            @click="storeComment">Add comment
                                    </button>
                                </div>
                                <hr>
                                <div class="inner-div" v-for="(comment,index) in comments" :key="index">
                                    <div class="row">
                                        <div style="font-weight: bold">{{comment.user.name}}</div>
                                        <div style="margin-left: 5px">. {{comment.created_at}}</div>
                                    </div>
                                    <div class="row" style="margin-top: 3px">{{comment.comment}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="change-logs">
                    <p class="panel-title"><span class="collapsed" data-toggle="collapse" data-target="#changeLogs"
                                                 aria-expanded="true" aria-controls="changeLogs"> Change Logs </span>
                    </p>
                    <div id="changeLogs" class="collapse">
                        <table class="table table-striped table-bordered table-hover dt-responsive" width="100%">
                            <thead>
                            <tr>
                                <th class="all">Date</th>
                                <th class="all">Title</th>
                                <th class="all">From</th>
                                <th class="all">To</th>
                                <th class="all">By</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(log,index) in changeLogs" :key="index">
                                <td>{{log.created_at}}</td>
                                <td>
                                    <ul v-for="(title,index2) in logParse(log,'title')" :key="index2">
                                        <li>{{ nameFormat(title) }}</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul v-for="(from,index2) in logParse(log,'from')" :key="index2">
                                        <li>{{ nameFormat(from) }}</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul v-for="(to,index2) in logParse(log,'to')" :key="index2">
                                        <li>{{ nameFormat(to) }}</li>
                                    </ul>
                                </td>
                                <td>{{log.created_by_name}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal for deposit reject-->
<!--        <div class="modal fade" id="depositReject" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">-->
<!--            <div class="modal-dialog" role="document">-->
<!--                <div class="modal-content">-->
<!--                    <div class="modal-header">-->
<!--                        <h5 class="modal-title" id="exampleModalLabel">Rejection Note</h5>-->
<!--                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
<!--                            <span aria-hidden="true">&times;</span>-->
<!--                        </button>-->
<!--                    </div>-->
<!--                    <div class="modal-body">-->
<!--                        <textarea class="form-control" v-model="rejectReason"></textarea>-->
<!--                    </div>-->
<!--                    <div class="modal-footer">-->
<!--                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>-->
<!--                        <button type="button" class="btn btn-primary">OK</button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <!-- Modal for deposit approve-->
<!--        <div class="modal fade" id="depositApproded" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">-->
<!--            <div class="modal-dialog" role="document">-->
<!--                <div class="modal-content">-->
<!--                    <div class="modal-body" style="display: flex;padding: 40px">-->

<!--                        <span>-->
<!--                            <i class='fas fa-exclamation-triangle' style='font-size:36px'></i>-->
<!--                        </span>-->
<!--                        <span style="margin: 8px 0 0 16px">Are you sure want to approve the repayment?</span>-->
<!--                    </div>-->
<!--                    <div class="modal-footer">-->
<!--                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>-->
<!--                        <button type="button" class="btn btn-primary">OK</button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
        <!-- Modal for status change description-->
        <div class="modal fade" id="descriptionModal" tabindex="-1" role="dialog"
             aria-labelledby="descriptionModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="descriptionModalLabel">Description for decline</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="description">Reason</label>
                        <input id="description" class="form-control" placeholder="reason for decline"
                               v-model="description" type="text">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button :disabled="is_disable_change_status_button" type="button" class="btn btn-primary"
                                v-on:click="submitChangeStatus('declined')">Change Status
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal for Sent SMS -->
        <div class="modal" id="sendSMS" v-if="data">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #F9F9F9;border-bottom: none">
                        <h5 class="modal-title">Write SMS to Borrower</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body" style="padding: 24px">
                        <div class="row">
                            <div class="col-md-3">Sent to</div>
                            <div class="col-md-9">
                                <span>{{data.partner.profile.name}} {{data.partner.profile.mobile}}</span>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col-md-3">Message</div>
                            <div class="col-md-9">
                                <textarea class="form-control" cols="30" rows="5" v-model="msg"></textarea>
                                <div>
                                    <button style="margin-top: 10px;" class="btn btn-primary" v-on:click="sendSMS">Send
                                        SMS <i class="fas fa-paper-plane"></i></button>
                                    <small class="float-right">({{msg.length}}/{{smsCount}})</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal for image show -->
        <div class="modal" id="showImage" v-if="data">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body" style="padding: 0">
                        <div>
                            <img :src="show_image" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal for document upload-->
        <div class="modal fade" id="fileUpload" tabindex="-1" role="dialog" aria-labelledby="fileUploadLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="bodered title-div" style="padding:8px">
                            <span><h3>{{nameFormat((document_for!=='nominee_document'?document_for:'2nd_grantor_document'))}}</h3> <h3>{{nameFormat(document_name)}}</h3></span>
                            <span class="img-icon" v-if="image">
                            <img :src="image" alt="">
                        </span>
                        </div>
                        <div style="padding:20px;border: 1px solid #cecece;">
                            <span>Upload New</span>
                            <div class="uploader"
                                 @dragenter="OnDragEnter"
                                 @dragleave="OnDragLeave"
                                 @dragover.prevent
                                 @drop="onDrop"
                                 :class="{ dragging: isDragging }">

                                <div v-show="!images.length">
                                    <p>Drop files here</p>
                                    <div style="margin-bottom: 10px;">-or-</div>
                                    <div class="file-input">
                                        <label for="file">Select File</label>
                                        <input class="btn btn-secondary" type="file" id="file" @change="onInputChange">
                                    </div>
                                    <div><span style="font-size:14px">[ Max: 8MB ]</span></div>
                                </div>
                                <div class="upload-control" v-show="images.length">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <input v-model="document_name" class="form-control"
                                                   style="padding:15px !important" type="text"
                                                   placeholder="Write document name here..."
                                                   :disabled="document_for!=='extras'">
                                        </div>
                                        <div class="col-md-3">
                                            <button style="padding:6px 30px" @click="upload">Upload</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="images-preview" v-show="images.length">
                                    <div class="img-wrapper" v-for="(image, index) in images" :key="index">
                                        <img :src="image" :alt="`Image Uplaoder ${index}`">
                                        <div class="details">
                                            <span class="name" v-text="files[index].name"></span>
                                            <span class="size" v-text="getFileSize(files[index].size)"></span>
                                        </div>
                                    </div>
                                    <div class="img-action">
                                        <button type="button" v-on:click="resetImage"
                                                class="btn btn-outline btn-outline-danger">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "loan-details",
        props: ['id'],
        components: {
            'Loader': () => import("./Loader"),
            Datepicker
        },
        data() {
            return {
                rejectReason: '',
                description: null,
                show_image: null,
                logged_in_user_name: '',
                loader: false,
                msg: '',
                placeholder_image: 'https://s3.ap-south-1.amazonaws.com/cdn-shebaxyz/images/profiles/avatar/default.jpg',
                msg_length: 1,
                data: null,
                legal_status: '',
                e_tin_company_issue_date: '',
                number_online_order_serve: '',
                sequrity: '',
                is_input_disable: true,
                isDragging: false,
                dragCount: 0,
                files: [],
                images: [],
                iconClassForLogs: "fas fa-caret-down",
                changeLogs: null,
                status_color: '',
                show_status: '',
                status_value: '',
                newComment: null,
                comments: [],
                config: null,
                image: '',
                document_name: null,
                document_for: '',
                loanTypes: {micro: "micro", term: "term"},
                repayments: {
                    due_amount: 0,
                    credit_amount: 0,
                    repayment_list:[]
                }
            }
        },
        created() {
        },
        computed: {
            ...mapGetters(['user']),
            smsCount() {
                if (this.msg.length > 160) {
                    if (this.msg.length > 306) {
                        if (this.msg.length > 459) {
                            if (this.msg.length > 612) {
                                if (this.msg.length > 766) {
                                    return 6;
                                } else {
                                    return 5;
                                }
                            } else {
                                return 4;
                            }
                        } else {
                            return 3;
                        }
                    } else {
                        return 2;
                    }
                } else {
                    return 1;
                }
            },
            is_disable_change_status_button() {
                return this.description === null || this.description === '';
            },
            is_micro_loan() {
                return this.data.loan_type === this.loanTypes.micro ? true : false;
            },
            has_reason() {
                return this.data.reject_reason ? true: false;
            }
        },
        mounted: function () {
            let self = this;
            self.loader = true;
            self.logged_in_user_name = self.user.name;
            var config = {
                headers: {'Authorization': "bearer " + self.user.token}
            };
            self.config = config;
            self.getLoanInfo(config);
            self.getComments(config);
            self.getLogs(config);
            self.getRepaymentHistory(config);
        },
        methods: {
            getRepaymentHistory(config) {
                const self = this;
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/repayment-list`, config)
                    .then(function (response) {
                        if (response.data.code === 200) {
                            self.repayments.credit_amount = response.data.data.credit_amount;
                            self.repayments.due_amount = response.data.data.due_amount;
                            self.repayments.repayment_list = response.data.data.repayment_list;
                        } else {
                            console.log(response.data)
                        }
                    });
            },
            pdfDownload(type) {
                const self = this;
                window.open(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/generate-pdf?token=${self.user.token}&pdf_type=${type}`)
            },
            showImage(img) {
                this.show_image = img;
                $('#showImage').modal('show');
            },
            downloadSingleImage(url) {
                const self = this;
                window.open(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/download-documents?url=${url}&token=${self.user.token}`)
            },
            downloadAllDocuments() {
                const self = this;
                self.loader = true;
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/download-documents?token=${self.user.token}`)
                    .then(response => {
                        self.loader = false;
                        if (response.data.code === 200) {
                            location.href = response.data.link;
                        } else {
                            alert('server error');
                        }
                    })
            },
            nameFormat(name) {
                if (name === null || typeof name === "number" || typeof name === "boolean") {
                    return name
                } else {
                    return name.replace(/_/g, ' ');
                }
            },
            resetImage() {
                this.images = [];
            },
            getLogs(config) {
                var self = this;
                self.loader = true;
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/logs`, config)
                    .then(function (response) {
                        self.loader = false;
                        if (response.data.code === 200) {
                            self.changeLogs = response.data.logs;
                        } else if (response.data.code === 403) {
                            self.$store.commit('logout');
                            self.$router.push({name: 'login'});
                        }
                    });
            },
            getComments(config) {
                var self = this;
                self.loader = true;
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/comments`, config)
                    .then(function (response) {
                        self.loader = false;
                        if (response.data.code === 200) {
                            self.comments = response.data.comment_lists || [];
                            self.loader = false;
                        } else if (response.data.code === 403) {
                            self.$store.commit('logout');
                            self.$router.push({name: 'login'});
                        }
                    });
            },
            getLoanInfo(config) {
                var self = this;
                axios.get(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/details`, config)
                    .then(function (response) {
                        self.loader = false;
                        if (response.data.code === 200) {
                            self.data = response.data.data;
                            self.initiateForm(self.data)
                            self.setEditable(response.data.data);
                        } else if (response.data.code === 403) {
                            self.$store.commit('logout');
                            self.$router.push({name: 'login'});
                        } else {
                            window.location = '/loans'
                        }
                    });
            },
            setEditable(data) {
                var self = this;
                var beforeDisbursed = ['applied', 'submitted', 'verified', 'approved', 'sanction_issued', 'hold', 'declined', 'withdrawal'];
                if (beforeDisbursed.includes(data.status.status)) {
                    self.is_input_disable = false;
                }
            },
            sendSMS() {
                var self = this;
                $('#sendSMS').modal('hide');
                self.loader = true;
                var config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                axios.post(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/send-sms`, {
                    message: self.msg
                }, config).then(function (response) {
                    if (response.data.code == 200) {
                        self.msg = '';
                        self.loader = false;
                        alert(response.data.message)
                    } else {
                        self.loader = false;
                        alert(response.data.message)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            changeStatus(status) {
                const self = this;
                if (status.status === 'declined') {
                    $('#descriptionModal').modal('show');
                } else {
                    self.submitChangeStatus(status.status);
                }
            },
            submitChangeStatus(status) {
                let self = this;
                $('#descriptionModal').modal('hide');
                var config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                self.loader = true;
                axios.post(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/status-change`, {
                    new_status: status,
                    description: self.description
                }, config).then(function (response) {
                    if (response.data.code === 200) {
                        location.reload();
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            initiateForm(data) {
                this.show_status = data.status.name;
                this.status_value = data.status.status;
                this.status_color = data.status_.color;
            },
            saveChanges() {
                let self = this;
                self.loader = true;
                axios.post(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}?token=${self.user.token}`, {
                    data: self.data
                }).then(function (response) {
                    self.loader = false;
                    if (response.data.code == 200) {
                        var config = {
                            headers: {'Authorization': "bearer " + self.user.token}
                        };
                        self.getLogs(config);
                        alert('Document uploaded successfully');
                    } else {
                        alert('Document upload fail')
                    }

                }).catch(function (error) {
                    console.log(error);
                });
            },
            discardChanges() {
                location.reload();
            },
            OnDragEnter(e) {
                e.preventDefault();
                this.dragCount++;
                this.isDragging = true;
                return false;
            },
            OnDragLeave(e) {
                e.preventDefault();
                this.dragCount--;
                if (this.dragCount <= 0)
                    this.isDragging = false;
            },
            onInputChange(e) {
                const files = e.target.files;
                Array.from(files).forEach(file => this.addImage(file));
            },
            onDrop(e) {
                e.preventDefault();
                e.stopPropagation();
                this.isDragging = false;
                const files = e.dataTransfer.files;
                Array.from(files).forEach(file => this.addImage(file));
            },
            addImage(file) {
                if (!file.type.match('image.*')) {
                    alert(`${file.name} is not an image`);
                    return;
                }
                if (file.size > 8000000) {
                    alert(`image size should be bellow then 8MB`);
                    return;
                }
                this.files.push(file);
                const img = new Image(),
                    reader = new FileReader();
                reader.onload = (e) => this.images.push(e.target.result);
                reader.readAsDataURL(file);
            },
            getFileSize(size) {
                const fSExt = ['Bytes', 'KB', 'MB', 'GB'];
                let i = 0;
                while (size > 900) {
                    size /= 1024;
                    i++;
                }
                return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`;
            },
            upload() {
                let self = this;
                self.loader = true;
                $('#fileUpload').modal('hide');
                var config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                const formData = new FormData();
                this.files.forEach(file => {
                    formData.append('picture', file);
                    formData.append('for', self.document_for);
                    formData.append('name', self.document_name);
                });
                axios.post(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/upload-documents?token=${self.user.token}`, formData)
                    .then(response => {
                        if (response.data.code === 200) {
                            location.reload();
                        }
                    })
            },
            storeComment() {
                let self = this;
                let formData = new FormData();
                formData.append('comment', self.newComment);

                var config = {
                    headers: {'Authorization': "bearer " + self.user.token}
                };
                axios.post(process.env.VUE_APP_API_URL + `/v2/loans/${self.$route.params.id}/comments`, {
                    comment: self.newComment,
                    from: 'bank-loan-portal',
                }, config).then(function (response) {
                    if (response.data.code == 200) {
                        self.newComment = null;
                        self.comments.unshift(response.data.comment);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            logParse(log, key) {
                let output_set = [];
                try {
                    const output_set = JSON.parse(log[key]);
                    if (output_set && output_set.length) return output_set;
                    return [log[key]];
                } catch (e) {
                    return [log[key]];
                }
            },
            updateSingleImage(image, image_for, name) {
                this.document_for = image_for;
                this.document_name = name;
                this.image = image;
                $('#fileUpload').modal('show');
            }
        }
    }
</script>
<style>
    .date-picker {
        height: 40px !important;
        border-radius: 5px !important;
        width: 100% !important;
        border: 1px solid #ced4da !important;
        padding: 12px !important;
    }

    .arrow-btn {
        padding-right: 30px;
        position: relative;
        border: none;
        outline: 0;
    }
    .arrow-btn:focus{
        box-shadow: none;
    }
    .arrow-left {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #eef1f5;
        position: absolute;
        right: 0;
        top: 0;
    }
</style>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700,800&display=swap');
    .approved {
        background: #069619;
        color: white;
    }
    .reject {
        background: #E8483C;
        color: white;
    }

    .img-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        position: relative;
        overflow: hidden;
        border: 1px solid #ddd;
        border-radius: 5px;

        img {
            display: flex;
            position: absolute;
            max-width: 100%;
        }
    }

    .title-div {
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            display: flex;
        }

        h3 {
            font-size: 15px;
            margin-bottom: 0;
            width: auto;
            margin-right: 10px;

            &:first-letter {
                text-transform: uppercase;
            }
        }
    }

    .disable-input {
        background-color: gray !important;
    }

    .enable-input {
        background-color: rgba(243, 247, 250, 0.7) !important;
    }

    .robi_retailer {
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 10px;
    }

    .image-container {
        position: relative;
        width: 50%;
        overflow: hidden;
        border-radius: 8px;

        img {
            max-width: 320px;
            max-height: 280px;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            position: absolute;
            border-radius: 8px;
        }

        h5 {
            text-transform: capitalize;
            font-size: 15px;
        }

        .image-div {
            display: flex;
            height: 220px;
            width: 100%;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            position: relative;
            border-radius: 8px;
            box-shadow: 0 0 4px 0px rgba(0, 0, 0, 0.2);
            background-color: rgba(0, 0, 0, 0.2);

            &.extras {
                img {
                    max-width: 100%;
                }
            }

        }
    }

    .button-right {
        position: absolute;
        right: 17px;
    }

    .image {
        opacity: 1;
        display: block;
        backface-visibility: hidden;
    }

    .middle {
        transition: .5s ease;
        opacity: 0;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        text-align: center;

        .text {
            a {
                &:not(:last-child) {
                    margin-right: 10px;
                }
            }
        }
    }

    .image-container:hover .image {
        opacity: .5;
        border: 2px solid;
    }

    .image-container:hover .middle {
        opacity: 1;
    }

    .loader-container {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .custom_button {
        padding: 6px 79px;
        font-size: 18px;
    }

    .status {
        display: list-item;
        list-style-type: disc;
        list-style-position: inside;
    }

    .btn-discard {
        padding: 6px 100px;
        color: #979797;
        border: 2px solid #979797;
        font-weight: 600;
        margin-left: 10px;
        font-size: 18px;
    }

    .panel-title span:after {
        font-family: "Font Awesome 5 Free";
        content: "\f0d8";
        display: inline-block;
        padding-right: 3px;
        vertical-align: middle;
        font-weight: 900;
        margin-left: 20px;
    }

    .panel-title span.collapsed:after {
        font-family: "Font Awesome 5 Free";
        margin-left: 20px;
        content: "\f0d7";
    }

    .background {
        background-color: #eef1f5;
    }

    .btn-extra {
        border-color: rgb(0, 145, 255) !important;
        background: white !important;
        color: rgb(0, 145, 255) !important;
    }

    .padding-20 {
        padding: 20px 0;
    }

    .margin-left-20 {
        margin-left: 20px;
    }

    .Loan-status {
        padding: 10px;
    }

    .loan-summery {
        background-color: #ffffff;
        padding: 30px;
        margin: 20px 0;
        color: #121212;
    }

    .loan-summery p {
        font-size: 18px;
        font-weight: 500;
    }

    .account-info {
        background-color: #ffffff;
        padding: 30px;
        margin: 20px 0;
        color: #121212;
    }

    .loan-summery span {
        font-family: 'Open Sans', sans-serif;
        font-size: 16px;
        color: #121212;
    }

    .account-info p {
        font-size: 18px;
        font-weight: 500;
    }

    .comment {
        background-color: #ffffff;
        padding: 30px;
        margin: 20px 0;
    }

    .comment p {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer
    }

    .change-logs {
        background-color: #ffffff;
        padding: 30px;
        margin: 20px 0;
    }

    .change-logs p {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
    }

    .item-align-center {
        align-items: center;
    }

    .inner-div {
        padding: 20px;
        color: #121212;;
    }

    .inner-div p {
        font-size: 24px;
    }

    /*.form-control {*/
    /*    height: 50px !important;*/
    /*}*/
    .form-control:focus {
        box-shadow: 0 0 8px 0 rgba(0, 123, 255, 0.25);
    }

    .row {
        margin-bottom: 20px !important;
    }

    .doc-div {
        max-width: 20%;
        padding: 15px;
    }

    .edit-button {
        position: absolute;
        right: 40px;
        cursor: pointer;
    }

    .bodered {
        border: 1px solid #cecece;
    }

    .uploader {
        width: 100%;
        color: #cecece;
        padding: 40px 15px;
        text-align: center;
        font-size: 18px;
        border: 2px dotted #cecece;
        position: relative;

        &.dragging {
            background: #fff;
            color: #2196F3;
            border: 3px dashed #2196F3;

            .file-input label {
                background: #2196F3;
                color: #fff;
            }
        }

        .file-input {
            width: 110px;
            margin: auto;
            height: 50px;
            position: relative;

            label,
            input {
                width: 100%;
                position: absolute;
                color: #121212;
                left: 0;
                top: 0;
                padding: 3px;
                margin-top: 5px;
                font-weight: 500;
                cursor: pointer;
                border: 1px solid #cecece;
                background-color: #e2e2e2
            }

            input {
                opacity: 0;
                z-index: -2;
            }
        }

        .images-preview {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 56px;

            .img-wrapper {
                width: 160px;
                display: flex;
                flex-direction: column;
                margin: 10px;
                height: 150px;
                justify-content: space-between;
                background: #fff;
                box-shadow: 5px 5px 20px #3e3737;

                img {
                    max-height: 105px;
                }
            }

            .details {
                font-size: 12px;
                background: #fff;
                color: #000;
                display: flex;
                flex-direction: column;
                align-items: self-start;
                padding: 3px 6px;

                .name {
                    overflow: hidden;
                    height: 18px;
                }
            }
        }

        .upload-control {
            position: absolute;
            width: 100%;
            background: #fff;
            bottom: 0;
            left: 0;
            border-top-left-radius: 7px;
            border-top-right-radius: 7px;
            padding: 10px;
            padding-bottom: 4px;
            text-align: right;

            button, label {
                background: #2196F3;
                border: 2px solid #03A9F4;
                border-radius: 3px;
                color: #fff;
                font-size: 15px;
                cursor: pointer;
            }

            label {
                padding: 2px 5px;
                margin-right: 10px;
            }
        }
    }
</style>
